export default function SchoolRevitalization() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
            <i className="ri-building-2-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">廃校の有効活用</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            地域の思い出を<br />
            新しい価値に変える
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            使われなくなった学校施設を、地域の新しい産業拠点として再生。<br />
            地域住民の思い出が詰まった場所を、未来への希望の場所へと変えていきます。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/1386d2135f69c3a23e5f42d534230ecf.jpg"
              alt="廃校の再生"
              className="w-full h-[400px] object-cover object-top rounded-xl"
            />
          </div>
          <div>
            <h3 className="text-3xl font-bold text-[#1A2332] mb-6">
              地域資源の再活用
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              少子化により使われなくなった学校施設は、地域にとって大きな課題となっています。C.GREENは、これらの施設を陸上養殖の拠点として活用することで、地域の課題を解決し、新しい価値を創造します。
            </p>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-recycle-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1A2332] mb-1">既存施設の有効活用</h4>
                  <p className="text-sm text-gray-600">教室、体育館、プールなどの施設を養殖設備として再利用</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-funds-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1A2332] mb-1">維持管理コストの削減</h4>
                  <p className="text-sm text-gray-600">自治体の施設維持費用を削減し、財政負担を軽減</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-heart-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1A2332] mb-1">地域の記憶を継承</h4>
                  <p className="text-sm text-gray-600">思い出の場所を新しい形で地域に残し、活用</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-8 rounded-xl border border-[#E8F5E9]">
            <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-6">
              <i className="ri-building-line text-white text-2xl"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1A2332] mb-3">施設の再生</h4>
            <p className="text-gray-600 leading-relaxed">
              老朽化した施設を最新の養殖設備として改修し、地域の新しいランドマークとして再生します。
            </p>
          </div>
          <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-8 rounded-xl border border-[#E8F5E9]">
            <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-6">
              <i className="ri-team-line text-white text-2xl"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1A2332] mb-3">地域との協働</h4>
            <p className="text-gray-600 leading-relaxed">
              地域住民や自治体と協力しながら、地域に根ざした事業運営を行います。
            </p>
          </div>
          <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-8 rounded-xl border border-[#E8F5E9]">
            <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-6">
              <i className="ri-seedling-line text-white text-2xl"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1A2332] mb-3">持続可能な運営</h4>
            <p className="text-gray-600 leading-relaxed">
              環境に配慮した循環型システムで、長期的に持続可能な事業を展開します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}